export const checkDevice = (isMobileDeviceWidth: string) => {
	let device = false;
	if (window && typeof window !== "undefined") {
		device = window.matchMedia(isMobileDeviceWidth).matches;
	}
	return device;
};
